import { useEffect, useState } from 'react'

export const useConsent = () => {
  const [hasTargetingConsent, setHasTargetingConsent] = useState(false)

  useEffect(() => {
    const checkConsent = () => {
      const state = window?.CookieScript?.instance?.currentState?.()
      const hasConsent = state?.categories?.includes('targeting')

      if (!window.uetq) return

      if (hasConsent) {
        setHasTargetingConsent(true)
        window.uetq.push('consent', 'update', {
          ad_storage: 'granted'
        })
      } else {
        window.uetq.push('consent', 'update', {
          ad_storage: 'granted'
        })
      }
    }

    const handleConsentGiven = () => {
      setHasTargetingConsent(true)
    }

    window.addEventListener('CookieScriptLoaded', checkConsent)
    window.addEventListener(
      'CookieScriptCategory-targeting',
      handleConsentGiven
    )

    return () => {
      window.removeEventListener('CookieScriptLoaded', checkConsent)
      window.removeEventListener(
        'CookieScriptCategory-targeting',
        handleConsentGiven
      )
    }
  }, [])

  return { hasTargetingConsent }
}
